import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import $ from 'jquery';
import {sortArrayOfObjects} from 'helpers/common-helper';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import MultiSelect from 'components/atoms/dropdowns/multi-select';

class StackItem extends Component {
    getListOfTeams() {
        const {games} = this.props;

        let teamNames = [];
        if (this.isStateReady(games, 'data')) {
            teamNames = getTeamNamesOfGames(games.getAllAsArr());
        }

        return teamNames;
    }

    selectTeam(e) {
        const {groupNumber, itemNumber} = this.props;
        this.props.dispatch(Action.set('NHLNameStackTeam', groupNumber, itemNumber, e.target.value));
    }

    removeItem() {
        const {groupNumber, itemNumber} = this.props;
        this.props.dispatch(Action.do('removeNHLNameStackItem', groupNumber, itemNumber));
    }

    onChangeExposure(e) {
        const {groupNumber, itemNumber} = this.props;
        this.props.dispatch(Action.set('NHLNameStackExposure', groupNumber, itemNumber, e.target.value));
    }

    selectPlayer(selectedValues) {
        const {players, groupNumber, itemNumber} = this.props;

        const selectedPlayers = selectedValues.map((value) => players.getPlayer(value));

        this.props.dispatch(Action.set('NHLNameStackPlayers', groupNumber, itemNumber, selectedPlayers));
    }

    preparePlayerOptions() {
        let {players, item, playersExclusion} = this.props,
            options = [];
        if (item.team) {
            Object.keys(players.data.players).map((key) => {
                let player = players.data.players[key];
                if (item.team === player.team && !player.isGoalie() && !player.isExcludedAnywhere()) {
                    let label = player.name;
                    if (0 < player.userLineGroup) {
                        label += ' L' + player.userLineGroup;
                    }
                    if (0 < player.userPpLine) {
                        label += ' PP' + player.userPpLine;
                    }
                    options.push({
                        value: player.playerId,
                        label: label,
                    });
                }
            });
        }

        options = sortArrayOfObjects(options, 'label', 'asc');

        return [...options];
    }

    render() {
        const {itemNumber, item} = this.props;
        const isFirstItem = 0 >= itemNumber;
        let teams = this.getListOfTeams();
        let playerOptions = this.preparePlayerOptions();

        return (
            <div className="form-row-new">
                <div className="team">
                    {isFirstItem ? <div className="form-text">Team</div> : null}
                    <select onChange={(e) => ::this.selectTeam(e)} value={item.team} className="form-control">
                        <option value="">Team</option>
                        {teams.map((team) => {
                            return (
                                <option key={team} value={team}>
                                    {team}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <div className="stack">
                    {isFirstItem ? <div className="form-text">Stack</div> : null}
                    <div className="percent-in">
                        <input
                            type="text"
                            className="form-control input-sm"
                            value={`${item.expMin}`}
                            onChange={(e) => ::this.onChangeExposure(e)}
                        />
                        <span className="percent">%</span>
                    </div>
                </div>
                <div className="players">
                    {isFirstItem ? <div className="form-text">Players</div> : null}
                    <MultiSelect onSelect={::this.selectPlayer} options={playerOptions} placeholder={'All players'} />
                </div>
                <div className="delete">
                    {!isFirstItem ? (
                        <button type="button" onClick={::this.removeItem}>
                            <i className="fa fa-times-circle"></i>
                        </button>
                    ) : null}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, stacks, playersExclusion} = state;
    return {
        games: playersData.games,
        stack: stacks.nhlName,
        players: playersData.players,
        playersExclusion,
    };
}

export default connect(mapStatesToProps)(StackItem);
